/* ════════════════════════════════════════════════════════════════
   SK Meal PDP — gallery, quantity, variant pills, real cart add,
   cross-sell quick-add, sticky bar, scroll reveal, macro count-up.
   Ported from the claude.ai/design "Meal Product Page": the prototype's
   localStorage bag is replaced with the real Shopify AJAX cart and the
   site cart drawer (sk-cart.js events: sk-cart:added / sk-cart:refresh).
   ════════════════════════════════════════════════════════════════ */
(function () {
  "use strict";
  if (window.SKMealLoaded) return;
  window.SKMealLoaded = true;

  function $(s, r) { return (r || document).querySelector(s); }
  function $all(s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); }
  function money(cents) {
    var n = (cents || 0) / 100;
    return "$" + (Number.isInteger(n) ? n : n.toFixed(2));
  }

  // Subscription state (set during init from the plan toggle, if present)
  var SK_SELLING_PLAN = "", SK_PLAN = "once", SK_HAS_SUB = false;

  /* ── Real Shopify cart add (carries selling_plan when subscribing) ── */
  function cartAdd(variantId, qty) {
    var item = { id: parseInt(variantId, 10), quantity: qty || 1 };
    if (SK_HAS_SUB && SK_PLAN === "sub" && SK_SELLING_PLAN) item.selling_plan = parseInt(SK_SELLING_PLAN, 10);
    return fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", "Accept": "application/json" },
      body: JSON.stringify({ items: [item] })
    }).then(function (r) {
      if (!r.ok) return r.json().then(function (e) { throw e; });
      return r.json();
    });
  }
  // Keep the header count + drawer contents in sync after an add (no slide-in).
  function syncQuiet() { document.dispatchEvent(new CustomEvent("sk-cart:refresh")); }

  /* ── Toast (quick-add feedback) ─────────────── */
  var toast = $("[data-sk-meal-toast]");
  var toastMsg = $("[data-sk-meal-toastmsg]");
  var toastTimer = null;
  function showToast(msg) {
    if (!toast || !toastMsg) return;
    toastMsg.textContent = msg;
    toast.classList.add("show");
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { toast.classList.remove("show"); }, 3000);
  }

  /* ── Gallery — click a frame to make it the hero ── */
  var gallery = $("[data-sk-meal-gallery]");
  if (gallery) {
    $all("figure", gallery).forEach(function (fig) {
      fig.addEventListener("click", function () {
        if (fig.classList.contains("active")) return;
        $all("figure", gallery).forEach(function (f) { f.classList.remove("active"); });
        fig.classList.add("active");
      });
    });
  }

  /* ── Buy block: variants, quantity, add ─────── */
  var form = $("#sk-meal-form");
  var idInput = $("[data-sk-meal-id]");
  var qtyInput = $("[data-sk-meal-qtyinput]");
  var actions = $(".sk-meal-buy .buy-actions");
  var qtyEl = $("[data-sk-meal-qty]");
  var sumEl = $("[data-sk-meal-sum]");
  var priceEl = $("[data-sk-meal-price]");
  var addBtn = $("[data-sk-meal-add]");
  var addLabel = $("[data-sk-meal-addlabel]");
  var sbPrice = $("[data-sk-meal-sbprice]");
  var sbQty = $("[data-sk-meal-sbqty]");
  var finalPriceEl = $("[data-sk-meal-finalprice]");

  var qty = 1;
  function unitPrice() { return actions ? parseInt(actions.getAttribute("data-unit-price"), 10) || 0 : 0; }

  function renderQty() {
    if (qtyEl) qtyEl.textContent = qty;
    if (qtyInput) qtyInput.value = qty;
    if (sumEl) sumEl.textContent = "= " + money(unitPrice() * qty);
    if (sbPrice) sbPrice.textContent = money(unitPrice() * qty);
    if (sbQty) sbQty.textContent = qty > 1 ? "× " + qty : "";
  }

  /* ── Subscription plan toggle (Subscribe & Save / One-time), Weekly-Box style ── */
  var planWrap = $("[data-sk-meal-plans]");
  var priceRow = $("[data-sk-meal-pricerow]");
  var subPriceEl = $("[data-sk-meal-subprice]");
  var oncePriceEl = $("[data-sk-meal-onceprice]");
  var curOnce = priceRow ? (parseInt(priceRow.getAttribute("data-once"), 10) || 0) : unitPrice();
  var curSub = priceRow ? (parseInt(priceRow.getAttribute("data-sub"), 10) || curOnce) : curOnce;
  var subTotalEl = $("[data-sk-meal-subtotal]");
  var onceTotalEl = $("[data-sk-meal-oncetotal]");
  var PLAN_UNIT = planWrap ? (planWrap.getAttribute("data-plan-unit") || "") : "";
  var curCount = priceRow ? (parseInt(priceRow.getAttribute("data-count"), 10) || 1) : 1;
  if (planWrap) {
    SK_HAS_SUB = true;
    SK_SELLING_PLAN = planWrap.getAttribute("data-plan-id") || "";
    SK_PLAN = "sub"; // default to Subscribe & Save
  }
  // Options the plan covers (",id,id,"). Recharge can attach a plan to only some options (e.g. just
  // the 14-meal pack); for the rest hide Subscribe & Save so the add never sends a plan it can't use.
  var planVariants = planWrap ? planWrap.getAttribute("data-plan-variants") : null;
  var planNote = $("[data-sk-meal-plannote]");
  var planPicked = false; // true once the shopper taps Subscribe or One-time themselves
  function syncPlanForVariant() {
    if (!planWrap || planVariants === null) return;
    var covered = !!idInput && planVariants.indexOf("," + idInput.value + ",") !== -1;
    var subBtn = planWrap.querySelector('[data-plan="sub"]');
    SK_HAS_SUB = covered;
    if (subBtn) subBtn.hidden = !covered;
    if (planNote) planNote.hidden = !covered;
    if (!covered) SK_PLAN = "once";
    else if (!planPicked) SK_PLAN = "sub";
  }
  syncPlanForVariant();
  function applyPlanPrice() {
    syncPlanForVariant();
    var p = (SK_HAS_SUB && SK_PLAN === "sub") ? curSub : curOnce;
    if (actions) actions.setAttribute("data-unit-price", p);
    if (priceEl) priceEl.textContent = money(p);
    if (finalPriceEl) finalPriceEl.textContent = money(p);
    if (planWrap) $all(".sk-plan-opt", planWrap).forEach(function (b) {
      b.setAttribute("aria-checked", b.getAttribute("data-plan") === SK_PLAN ? "true" : "false");
    });
    renderQty();
  }
  var savePillEl = $("[data-sk-meal-savepill]");
  var wasWrapEl = $("[data-sk-meal-waswrap]");
  var subNameEl = $("[data-sk-meal-subname]");
  var topupNoteEl = $("[data-sk-meal-topupnote]");
  var wasEl = $("[data-sk-meal-was]");
  var compareEl = $("[data-sk-meal-compare]");   // headline sale strikethrough (compare-at price)
  function setVariantPrices(once, sub, count, compare) {
    // keep the headline sale "was" in sync with the chosen variant (hide when not on sale)
    if (compareEl) {
      var cmp = parseInt(compare, 10) || 0;
      if (cmp > (once || 0)) { compareEl.textContent = money(cmp); compareEl.hidden = false; }
      else { compareEl.hidden = true; }
    }
    curOnce = once || 0;
    curSub = (sub != null) ? sub : curOnce;
    if (count) curCount = count;
    var cnt = curCount || 1;
    // headline = per-unit (e.g. per-pot) when PLAN_UNIT is set, else the pack total
    var subHead = PLAN_UNIT ? Math.round(curSub / cnt) : curSub;
    var onceHead = PLAN_UNIT ? Math.round(curOnce / cnt) : curOnce;
    if (subPriceEl) subPriceEl.textContent = money(subHead);
    if (oncePriceEl) oncePriceEl.textContent = money(onceHead);
    if (subTotalEl) subTotalEl.textContent = money(curSub);   // pack total in the subtext
    if (onceTotalEl) onceTotalEl.textContent = money(curOnce);
    if (wasEl) wasEl.textContent = money(curOnce);
    var packSaved = curOnce - curSub;
    if (savePillEl) {
      savePillEl.textContent = PLAN_UNIT ? ("Save " + money(onceHead - subHead) + "/" + PLAN_UNIT) : ("Save " + money(packSaved));
      savePillEl.hidden = packSaved <= 0;
    }
    if (wasWrapEl) wasWrapEl.hidden = packSaved <= 0;
    // no saving on this variant: call it a weekly top-up instead of promising "Save"
    if (subNameEl) subNameEl.textContent = packSaved > 0 ? subNameEl.dataset.saveLabel : subNameEl.dataset.topupLabel;
    if (topupNoteEl) topupNoteEl.hidden = packSaved > 0;
    applyPlanPrice();
  }
  if (planWrap) {
    $all(".sk-plan-opt", planWrap).forEach(function (b) {
      b.addEventListener("click", function () { planPicked = true; SK_PLAN = b.getAttribute("data-plan"); applyPlanPrice(); });
    });
  }

  $all("[data-sk-meal-step]").forEach(function (btn) {
    btn.addEventListener("click", function () {
      var d = parseInt(btn.getAttribute("data-sk-meal-step"), 10);
      qty = Math.max(1, Math.min(20, qty + d));
      renderQty();
    });
  });

  // Variant pills → set current variant, price, availability.
  $all("[data-sk-meal-variants] button[data-variant-id]").forEach(function (pill) {
    pill.addEventListener("click", function () {
      if (pill.hasAttribute("disabled")) return;
      $all("[data-sk-meal-variants] button[data-variant-id]").forEach(function (p) { p.setAttribute("aria-pressed", "false"); });
      pill.setAttribute("aria-pressed", "true");
      var vid = pill.getAttribute("data-variant-id");
      var price = parseInt(pill.getAttribute("data-price"), 10) || 0;
      var sub = parseInt(pill.getAttribute("data-subprice"), 10);
      var compare = parseInt(pill.getAttribute("data-compare"), 10) || 0;
      if (idInput) idInput.value = vid;
      var nCell = pill.querySelector(".n");
      setVariantPrices(price, isNaN(sub) ? price : sub, nCell ? (parseInt(nCell.textContent, 10) || 1) : 1, compare);
    });
  });

  // Pot mode: 2D flavour × size resolver. Picks the variant matching the chosen flavour + size.
  (function () {
    var potWrap = $("[data-sk-meal-pot]");
    if (!potWrap) return;
    var map;
    try { map = JSON.parse(potWrap.getAttribute("data-pot-variants")); } catch (e) { return; }
    var flavBtns = $all("[data-sk-meal-flavours] [data-flavour]");
    var sizeBtns = $all("[data-sk-meal-sizes] [data-size]");
    var addLabelText = (addLabel && addLabel.textContent.trim() && addLabel.textContent.trim() !== "Sold out")
      ? addLabel.textContent.trim() : "Add to bag";
    // redraw the macro donut for the chosen variant (per-flavour macros)
    var dCal = $("[data-sk-meal-cal]"), dP = $("[data-sk-meal-mp]"), dC = $("[data-sk-meal-mc]"), dF = $("[data-sk-meal-mf]");
    var dArcP = $('[data-sk-meal-arc="prot"]'), dArcC = $('[data-sk-meal-arc="carb"]'), dArcF = $('[data-sk-meal-arc="fat"]');
    // average flavours (e.g. Mixed Bundle): swap the donut labels so they note an average, not "per pot".
    var mPanel = $(".macro-panel"), calLbl = $(".donut-center .cal-lbl"), avgLbl = $(".macro-readout .avg");
    var calLblDef = calLbl ? calLbl.textContent : "", avgLblDef = avgLbl ? avgLbl.textContent : "";
    var calLblAvg = (mPanel && mPanel.getAttribute("data-avg-cal-label")) || calLblDef;
    var avgLblAvg = (mPanel && mPanel.getAttribute("data-avg-macro-label")) || avgLblDef;
    function setMacroLabels(isAvg) {
      if (calLbl) calLbl.textContent = isAvg ? calLblAvg : calLblDef;
      if (avgLbl) avgLbl.textContent = isAvg ? avgLblAvg : avgLblDef;
    }
    var D_R = 56, D_C = 2 * Math.PI * D_R, D_GAP = 7, D_USE = D_C - D_GAP * 3;
    function drawDonut(p, c, f, cal) {
      p = +p || 0; c = +c || 0; f = +f || 0;
      if (dCal && cal) dCal.textContent = Math.round(cal);
      if (dP) dP.innerHTML = p + "<small>g</small>";
      if (dC) dC.innerHTML = c + "<small>g</small>";
      if (dF) dF.innerHTML = f + "<small>g</small>";
      var kp = p * 4, kc = c * 4, kf = f * 9, tot = kp + kc + kf;
      if (!tot) return;
      var segs = [[dArcP, kp / tot], [dArcC, kc / tot], [dArcF, kf / tot]], cur = 0;
      segs.forEach(function (s) {
        var len = Math.max(D_USE * s[1], 0.5);
        if (s[0]) { s[0].style.strokeDasharray = len + " " + (D_C - len); s[0].style.strokeDashoffset = String(-cur); }
        cur += len + D_GAP;
      });
    }
    function chosen(btns, attr) {
      var b = btns.filter(function (x) { return x.getAttribute("aria-pressed") === "true"; })[0] || btns[0];
      return b ? b.getAttribute(attr) : null;
    }
    function resolve() {
      var f = chosen(flavBtns, "data-flavour"), s = chosen(sizeBtns, "data-size");
      var v = map.filter(function (m) { return m.f === f && m.s === s; })[0];
      if (!v) return;
      if (idInput) idInput.value = v.id;
      var sizeMatch = (v.s || "").match(/\d+/);
      setVariantPrices(v.price, v.sub != null ? v.sub : v.price, sizeMatch ? parseInt(sizeMatch[0], 10) : 1);
      if (v.cal) drawDonut(v.pro, v.car, v.fat, v.cal);
      setMacroLabels(!!v.avg);
      if (addBtn) addBtn.disabled = !v.avail;
      if (addLabel) addLabel.textContent = v.avail ? addLabelText : "Sold out";
      // reflect the chosen flavour on the gallery: make its image the hero
      var selFlav = chosen(flavBtns, "data-flavour");
      var figs = $all("[data-sk-meal-gallery] figure");
      if (selFlav && figs.length) {
        var matched = figs.filter(function (fig) { return fig.getAttribute("data-flavour") === selFlav; })[0];
        if (matched && !matched.classList.contains("active")) {
          figs.forEach(function (fig) { fig.classList.remove("active"); });
          matched.classList.add("active");
        }
      }
    }
    function bind(btns) {
      btns.forEach(function (btn) {
        btn.addEventListener("click", function () {
          if (btn.hasAttribute("disabled")) return;
          btns.forEach(function (p) { p.setAttribute("aria-pressed", "false"); });
          btn.setAttribute("aria-pressed", "true");
          resolve();
        });
      });
    }
    bind(flavBtns); bind(sizeBtns);
    // two-way: clicking a flavour's image selects that flavour
    $all("[data-sk-meal-gallery] figure[data-flavour]").forEach(function (fig) {
      fig.addEventListener("click", function () {
        var f = fig.getAttribute("data-flavour");
        var btn = flavBtns.filter(function (b) { return b.getAttribute("data-flavour") === f; })[0];
        if (btn && btn.getAttribute("aria-pressed") !== "true") btn.click();
      });
    });
    // sync the initial state (hero image especially) to the pre-selected variant (e.g. ?variant= from a flavour card)
    resolve();
  })();

  // Per-tier macro panel: redraw the donut + numbers when a goal card is tapped.
  (function () {
    var panel = $(".sk-meal-buy .macro-panel");
    if (!panel) return;
    var calEl = $("[data-sk-meal-cal]", panel);
    var mpEl = $("[data-sk-meal-mp]", panel), mcEl = $("[data-sk-meal-mc]", panel), mfEl = $("[data-sk-meal-mf]", panel);
    var arcP = $('[data-sk-meal-arc="prot"]', panel), arcC = $('[data-sk-meal-arc="carb"]', panel), arcF = $('[data-sk-meal-arc="fat"]', panel);
    var R = 56, C = 2 * Math.PI * R, GAP = 7, usable = C - GAP * 3;
    function draw(p, c, f) {
      var kp = p * 4, kc = c * 4, kf = f * 9, tot = kp + kc + kf;
      if (!tot) return;
      var segs = [[arcP, kp / tot], [arcC, kc / tot], [arcF, kf / tot]], cur = 0;
      segs.forEach(function (s) {
        var len = Math.max(usable * s[1], 0.5);
        if (s[0]) { s[0].style.strokeDasharray = len + " " + (C - len); s[0].style.strokeDashoffset = String(-cur); }
        cur += len + GAP;
      });
    }
    var deltaWrap = $("[data-sk-meal-deltas]", panel);
    var baseEl = $('.sk-meal-buy .tier-btn[data-t="lifestyle"][data-cal]');
    function num(el, attr) { return parseFloat(el && el.getAttribute(attr)) || 0; }
    function buildDeltas(el) {
      if (!deltaWrap) return;
      deltaWrap.innerHTML = "";
      // No baseline, or this IS the baseline → show the "everyday baseline" tag.
      if (!baseEl || el === baseEl || el.getAttribute("data-t") === baseEl.getAttribute("data-t")) {
        var b = document.createElement("span"); b.className = "delta base"; b.textContent = "Your everyday baseline"; deltaWrap.appendChild(b); return;
      }
      [{ lbl: "cal", v: num(el, "data-cal") - num(baseEl, "data-cal") },
       { lbl: "g protein", v: num(el, "data-p") - num(baseEl, "data-p") },
       { lbl: "g carbs", v: num(el, "data-c") - num(baseEl, "data-c") },
       { lbl: "g fat", v: num(el, "data-f") - num(baseEl, "data-f") }]
        .filter(function (d) { return Math.abs(d.v) >= 4; })
        .forEach(function (d) {
          var s = document.createElement("span"); s.className = "delta up";
          s.textContent = (d.v > 0 ? "+" : "−") + Math.abs(Math.round(d.v)) + " " + d.lbl;
          deltaWrap.appendChild(s);
        });
      var tag = document.createElement("span"); tag.className = "delta base"; tag.textContent = "vs Lifestyle"; deltaWrap.appendChild(tag);
    }
    function apply(el) {
      var p = parseFloat(el.getAttribute("data-p")) || 0,
          c = parseFloat(el.getAttribute("data-c")) || 0,
          f = parseFloat(el.getAttribute("data-f")) || 0,
          cal = parseFloat(el.getAttribute("data-cal")) || Math.round(p * 4 + c * 4 + f * 9);
      if (!p && !c && !f) return;
      if (calEl) calEl.textContent = cal;
      if (mpEl) mpEl.innerHTML = p + "<small>g</small>";
      if (mcEl) mcEl.innerHTML = c + "<small>g</small>";
      if (mfEl) mfEl.innerHTML = f + "<small>g</small>";
      draw(p, c, f);
      buildDeltas(el);
    }
    $all('.sk-meal-buy .tier-btn[data-cal]').forEach(function (card) {
      card.addEventListener("click", function () { apply(card); });
    });
    // Normalise the initial display (e.g. "58.6g" not "58.60") from the selected card.
    var pressed = $('.sk-meal-buy .tier-btn[aria-pressed="true"][data-cal]');
    if (pressed) apply(pressed);
  })();

  // Per-tier accent: recolour the buy block (macro panel donut + background) when a goal is
  // chosen, the way the Weekly Box does. Sets data-tier on the section root.
  (function () {
    var root = $(".sk-meal-buy");
    if (!root) return;
    var stmt = $(".sk-meal-buy [data-sk-meal-statement]");
    function setTier(el) {
      var t = el && el.getAttribute("data-t");
      if (t) {
        root.setAttribute("data-tier", t);        // macro panel keys off this
        document.body.setAttribute("data-tier", t); // page-wide green→tier accent, like the Weekly Box
      }
      if (stmt && el) { var bl = el.getAttribute("data-blurb"); if (bl != null && bl !== "") stmt.innerHTML = bl; }
    }
    $all('.sk-meal-buy .tier-btn[data-t]').forEach(function (b) {
      b.addEventListener("click", function () { setTier(b); });
    });
    setTier($('.sk-meal-buy .tier-btn[aria-pressed="true"][data-t]') || $('.sk-meal-buy .tier-btn[data-t]'));
  })();

  function currentVariantId() { return idInput ? idInput.value : null; }

  function doMainAdd() {
    var vid = currentVariantId();
    if (!vid || (addBtn && addBtn.disabled)) return;
    if (addBtn) addBtn.disabled = true;
    cartAdd(vid, qty)
      .then(function () {
        showToast("Added to your bag");   // confirm without yanking the drawer open
        syncQuiet();                      // sync header badge + drawer contents
        qty = 1; renderQty();
        if (addBtn) addBtn.disabled = false;
      })
      .catch(function (err) {
        if (addBtn) addBtn.disabled = false;
        showToast((err && err.description) || "Couldn't add that. Please try again.");
      });
  }

  if (form) {
    form.addEventListener("submit", function (e) { e.preventDefault(); doMainAdd(); });
  }
  // Subscription products render form-less (to dodge Recharge) — wire the add button directly.
  var noForm = $("[data-sk-meal-noform]");
  if (!form && noForm && addBtn) addBtn.addEventListener("click", doMainAdd);
  var sbAdd = $("[data-sk-meal-sbadd]");
  if (sbAdd) sbAdd.addEventListener("click", doMainAdd);

  // Closing-section final add (always qty 1 of the current variant).
  var finalBtn = $("[data-sk-meal-final]");
  if (finalBtn) {
    finalBtn.addEventListener("click", function () {
      var vid = currentVariantId();
      if (!vid) return;
      finalBtn.disabled = true;
      cartAdd(vid, 1)
        .then(function () { showToast("Added to your bag"); syncQuiet(); finalBtn.disabled = false; })
        .catch(function (err) { finalBtn.disabled = false; showToast((err && err.description) || "Couldn't add that."); });
    });
  }

  /* ── Cross-sell rails: goal-tier selector (multi-variant cards) ── */
  // Point every product link in the card at the chosen variant, so clicking
  // through opens the meal PDP pre-selected to that tier (?variant=…).
  function railLinkCard(box, vid) {
    var card = box.closest(".xcard");
    if (!card || !vid) return;
    $all("a[href]", card).forEach(function (a) {
      var base = (a.getAttribute("href") || "").split("?")[0];
      if (base) a.setAttribute("href", base + "?variant=" + vid);
    });
  }
  $all(".sk-meal [data-rail-multi]").forEach(function (box) {
    var segs = $all("[data-rail-seg]", box);
    var priceEl = box.querySelector("[data-rail-price]");
    railLinkCard(box, box.getAttribute("data-active")); // prime links to the default tier
    segs.forEach(function (seg) {
      if (seg.hasAttribute("disabled")) return;
      seg.addEventListener("click", function () {
        segs.forEach(function (s) { s.setAttribute("aria-pressed", s === seg ? "true" : "false"); });
        var vid = seg.getAttribute("data-variant");
        box.setAttribute("data-active", vid);
        box.setAttribute("data-active-goal", seg.getAttribute("data-t") || "");
        var pf = seg.getAttribute("data-price-fmt");
        if (priceEl && pf) priceEl.textContent = pf;
        railLinkCard(box, vid);
      });
    });
  });

  /* ── Cross-sell rails: add the active variant (multi-variant cards) ── */
  $all(".sk-meal [data-rail-add]").forEach(function (btn) {
    var box = btn.closest("[data-rail-multi]");
    if (!box) return;
    var name = btn.getAttribute("data-name") || "Item";
    var label = btn.textContent;
    btn.addEventListener("click", function () {
      var vid = box.getAttribute("data-active");
      if (!vid) return;
      btn.setAttribute("disabled", "disabled");
      cartAdd(vid, 1)
        .then(function () {
          btn.classList.add("added");
          btn.textContent = "Added ✓";
          showToast(name + " added to your bag");
          syncQuiet();
          setTimeout(function () {
            btn.classList.remove("added");
            btn.textContent = label;
            btn.removeAttribute("disabled");
          }, 1600);
        })
        .catch(function (err) {
          btn.removeAttribute("disabled");
          showToast((err && err.description) || "Couldn't add that. Please try again.");
        });
    });
  });

  /* ── Cross-sell rails: quick-add (silent + toast) ── */
  $all(".sk-meal .qadd").forEach(function (btn) {
    if (btn.hasAttribute("disabled")) return;
    var vid = btn.getAttribute("data-variant-id");
    if (!vid) return;
    var name = btn.getAttribute("data-name") || "Item";
    var label = btn.textContent;
    btn.addEventListener("click", function () {
      btn.setAttribute("disabled", "disabled");
      cartAdd(vid, 1)
        .then(function () {
          btn.classList.add("added");
          btn.textContent = "Added ✓";
          showToast(name + " added to your bag");
          syncQuiet();      // keep cart in sync without yanking the drawer open mid-browse
          setTimeout(function () {
            btn.classList.remove("added");
            btn.textContent = label;
            btn.removeAttribute("disabled");
          }, 1600);
        })
        .catch(function (err) {
          btn.removeAttribute("disabled");
          showToast((err && err.description) || "Couldn't add that. Please try again.");
        });
    });
  });

  /* ── Sticky mobile bar — show once buy block scrolls past ── */
  var stickybar = $("[data-sk-meal-stickybar]");
  var buyblock = $("#sk-meal-buyblock");
  if (stickybar && buyblock && "IntersectionObserver" in window) {
    new IntersectionObserver(function (entries) {
      var e = entries[0];
      stickybar.classList.toggle("show", !e.isIntersecting && e.boundingClientRect.top < 0);
    }, { threshold: 0 }).observe(buyblock);
  }

  /* ── Soft reveal on scroll ──────────────────── */
  var reduced = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  var revealEls = $all(".sk-meal[data-reveal], .sk-meal [data-reveal]");
  if (!reduced && "IntersectionObserver" in window) {
    var ro = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add("in"); ro.unobserve(e.target); }
      });
    }, { rootMargin: "0px 0px -8% 0px", threshold: 0 });
    revealEls.forEach(function (el) { ro.observe(el); });
  } else {
    revealEls.forEach(function (el) { el.classList.add("in"); });
  }

  /* ── Macro numbers count up on scroll-in ────── */
  var counters = $all(".sk-meal-macros .count");
  function runCounter(el) {
    var target = parseInt(el.getAttribute("data-count"), 10);
    if (isNaN(target)) return;
    var dur = 700, t0 = performance.now();
    function frame(now) {
      var k = Math.min((now - t0) / dur, 1);
      var eased = 1 - Math.pow(1 - k, 3);
      el.textContent = Math.round(target * eased);
      if (k < 1) requestAnimationFrame(frame);
    }
    requestAnimationFrame(frame);
    setTimeout(function () { el.textContent = target; }, dur + 80);
  }
  if (!reduced && "IntersectionObserver" in window) {
    var co = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { runCounter(e.target); co.unobserve(e.target); }
      });
    }, { threshold: 0.4 });
    counters.forEach(function (el) { co.observe(el); });
  }

  renderQty();
})();
